module.exports = __webpack_public_path__ + "static/media/goal03.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Tekentool/assets/goals/goal03.svg
// module id = 63
// module chunks = 0